import { createRecordType, defineMigrations } from "@supersig/store";
import { T } from "@supersig/validate";
import { mapObjectMapValues } from "../../utils";
import { createProductValidator } from "../products/SWBaseProduct";
/** @public */ /** @internal */ export const rootProductVersions = {};
/** @internal */ export const rootProductMigrations = defineMigrations({});
/** @public */ export function isProduct(record) {
    if (!record) return false;
    return record.typeName === "product";
}
/** @public */ export function isProductId(id) {
    if (!id) return false;
    return id.startsWith("product:");
}
export const createProductIdPrefix = (type)=>`product:${type}:`;
export function createProductId({ type, identifier }) {
    return `product:${type}:${identifier}`;
}
/** @internal */ export function createProductRecordType(products) {
    return createRecordType("product", {
        migrations: undefined,
        scope: "session",
        validator: T.model("product", T.union("type", mapObjectMapValues(products, (type, { props, meta })=>createProductValidator(type, props, meta))))
    }).withDefaultProperties(()=>({
            meta: {}
        }));
}
export function castProductId(id) {
    return {
        toProductDetailId () {
            return id.replace(/^product:/, "product_detail:");
        }
    };
}
export function castProductDetailId(id) {
    return {
        toProductId () {
            return id.replace(/^product_detail:/, "product:");
        }
    };
}
export function castProductDetail(productVariant) {
    return {
        toProduct () {
            const id = castProductDetailId(productVariant.id).toProductId();
            const { rawPrice, rawTrialPeriodPrice, trialPeriodDays, period, ...rest } = productVariant;
            return {
                ...rest,
                typeName: "product",
                id
            };
        }
    };
}
export function castProduct(product) {
    return {
        toProductVariant (props) {
            const id = castProductId(product.id).toProductDetailId();
            return {
                ...product,
                ...props,
                typeName: "product_detail",
                id
            };
        }
    };
}
